import React, { createContext, useCallback, useContext, useEffect, useId, useMemo, useState } from 'react';

/** Calendar grouping is independent of workflow completion or whether a tape exists. */
export const isUpcomingPeriod = (start: string, businessDate: string) => Boolean(businessDate) && start.slice(0, 10) > businessDate.slice(0, 10);
export interface ReviewPeriod { id: number; label: string; start: string; end: string; status: string; }
export const periodQuery = (search: string | URLSearchParams, id: number) => {
  const next = new URLSearchParams(search);
  next.set('period', String(id)); next.delete('periodId');
  // These identify evidence or an aggregate belonging to the old review context.
  ['quarter','tape','compareTape','delivery','reportId','poolSearch','reason','poolBucket','poolDimension'].forEach(key => next.delete(key));
  if (next.has('collateralView')) next.set('collateralView', 'period');
  return next;
};
const Context = createContext<{ locked: boolean; lock: (id: string, busy: boolean) => void }>({locked:false, lock:()=>{}});
export function ReviewPeriodProvider({children}: {children: React.ReactNode}) {
  const [locks, setLocks] = useState<Set<string>>(new Set());
  const lock = useCallback((id: string, busy: boolean) => setLocks(old => {
    if (old.has(id) === busy) return old;
    const next = new Set(old); if (busy) next.add(id); else next.delete(id); return next;
  }), []);
  const value = useMemo(() => ({locked:locks.size > 0, lock}), [locks, lock]);
  return <Context.Provider value={value}>{children}</Context.Provider>;
}
export const useReviewPeriodLocked = () => useContext(Context).locked;
export function useReviewPeriodLock(busy: boolean) {
  const id = useId(); const {lock} = useContext(Context);
  useEffect(() => { lock(id, busy); return () => lock(id, false); }, [id, busy, lock]);
}
